import { useState, useCallback, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import ExportModalImage from "../../components/ExportModalImage";
import PortalPopup from "../../components/PortalPopup";
import DownloadModalTables from "../../components/DownloadModalTables";
import DebtCollectionNav from "../../components/DebtCollectionNav";
import NavigationPanelLawyer from "../../components/NavigationPanelLawyer";
import RevenueFilter from "../../components/RevenueFilter";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import TabState from "../../components/TabState";
import Footer from "../../components/Footer";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Area,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import CTAs from "../../components/CTAs";
import { SearchNormal1 } from "iconsax-reactjs";

const Legal_proceedings_3 = () => {
  const navigate = useNavigate();
  const [isExportModalImageOpen, setExportModalImageOpen] = useState(false);
  const [isExportModalImage1Open, setExportModalImage1Open] = useState(false);
  const [isExportModalImage2Open, setExportModalImage2Open] = useState(false);
  const [isDownloadModalTablesOpen, setDownloadModalTablesOpen] =
    useState(false);
  const [isRevenueFilterOpen, setRevenueFilterOpen] = useState(false);
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);

  const onClickCasesOverview = useCallback(() => {
    navigate("/legal_1");
  }, [navigate]);

  const onClickBillingSchedule = useCallback(() => {
    navigate("/legal_2");
  }, [navigate]);

  const openExportModalImage = useCallback(() => {
    setExportModalImageOpen(true);
  }, []);

  const closeExportModalImage = useCallback(() => {
    setExportModalImageOpen(false);
  }, []);

  const openExportModalImage1 = useCallback(() => {
    setExportModalImage1Open(true);
  }, []);

  const closeExportModalImage1 = useCallback(() => {
    setExportModalImage1Open(false);
  }, []);

  const openExportModalImage2 = useCallback(() => {
    setExportModalImage2Open(true);
  }, []);

  const closeExportModalImage2 = useCallback(() => {
    setExportModalImage2Open(false);
  }, []);

  const openDownloadModalTables = useCallback(() => {
    setDownloadModalTablesOpen(true);
  }, []);

  const closeDownloadModalTables = useCallback(() => {
    setDownloadModalTablesOpen(false);
  }, []);

  const openRevenueFilter = useCallback(() => {
    setRevenueFilterOpen(true);
  }, []);

  const closeRevenueFilter = useCallback(() => {
    setRevenueFilterOpen(false);
  }, []);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  const navItems = [
    {
      text: "Dashboard",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/dashboard",
    },
    {
      text: "Legal proceedings & billing",
      bgColor: "bg-primary-primary-50",
      textColor: "text-neutrals-neutral-900",
      hoverBgColor: "bg-primary-primary-50",
      hoverTextColor: "text-neutrals-neutral-900",
      path: "",
    },
    {
      text: "Pre-LBA checks",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/prelbacheck",
    },
    {
      text: "Client-debtor interaction",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/cdi1",
    },
  ];

  const dumyData = [
    { month: "January", revenue: 45 },
    { month: "February", revenue: 35 },
    { month: "March", revenue: 20 },
    { month: "April", revenue: 60 },
    { month: "May", revenue: 53 },
    { month: "June", revenue: 45 },
    { month: "July", revenue: 45 },
    { month: "August", revenue: 20 },
    { month: "September", revenue: 40 },
    { month: "October", revenue: 55 },
    { month: "November", revenue: 50 },
    { month: "December", revenue: 30 },
  ];

  const [data, setData] = useState(dumyData); //For Timeline Visualistaion Line Graph

  //Function to fetch real data
  const fetchData = async () => {
    try {
      const response = await fetch(""); //Example endpoint
      const result = await response.json();
      setData(result);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(() => {
      setData(dumyData);
    }, 30000); // Refresh with dummy data (replace with API call later)
    return () => clearInterval(interval);
  }, []);
  //Function ended

  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  const revenue_breakdown = [
    {
      name: "Paras Mistry",
      type: "Debt",
      amount: "£20,000",
      court_fees: "£2000",
      legal_fees: "£10,000",
      revenue: "£32,000",
    },
    {
      name: "Paras Mistry",
      type: "Debt",
      amount: "£20,000",
      court_fees: "£2000",
      legal_fees: "£10,000",
      revenue: "£32,000",
    },
    {
      name: "Paras Mistry",
      type: "Debt",
      amount: "£20,000",
      court_fees: "£2000",
      legal_fees: "£10,000",
      revenue: "£32,000",
    },
    {
      name: "Paras Mistry",
      type: "Debt",
      amount: "£20,000",
      court_fees: "£2000",
      legal_fees: "£10,000",
      revenue: "£32,000",
    },
    {
      name: "Paras Mistry",
      type: "Debt",
      amount: "£20,000",
      court_fees: "£2000",
      legal_fees: "£10,000",
      revenue: "£32,000",
    },
    {
      name: "Paras Mistry",
      type: "Debt",
      amount: "£20,000",
      court_fees: "£2000",
      legal_fees: "£10,000",
      revenue: "£32,000",
    },
    {
      name: "Paras Mistry",
      type: "Debt",
      amount: "£20,000",
      court_fees: "£2000",
      legal_fees: "£10,000",
      revenue: "£32,000",
    },
    {
      name: "Paras Mistry",
      type: "Debt",
      amount: "£20,000",
      court_fees: "£2000",
      legal_fees: "£10,000",
      revenue: "£32,000",
    },
    {
      name: "Paras Mistry",
      type: "Debt",
      amount: "£20,000",
      court_fees: "£2000",
      legal_fees: "£10,000",
      revenue: "£32,000",
    },
    {
      name: "Paras Mistry",
      type: "Debt",
      amount: "£20,000",
      court_fees: "£2000",
      legal_fees: "£10,000",
      revenue: "£32,000",
    },
  ];

  const filteredRevenue =
    activeTab === "all"
      ? revenue_breakdown
      : revenue_breakdown.filter(
          (debtor) => debtor.status.toLowerCase() === activeTab.toLowerCase()
        );

  const searchedCases = filteredRevenue.filter(
    (debtor) =>
      debtor.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.type.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.amount.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.court_fees.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.legal_fees.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.revenue.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Pie Chart
  const COLORS = ["#2563EB", "#BBCFF9", "#143681"]; // Active segment colors
  const BG_COLOR = "#EDF2F4"; // Background color for empty space
  const COLORS_2 = ["#2563EB", "#BBCFF9", "#143681"]; // Colors for true positive and false positive

  const [data1, setData1] = useState([
    { name: "Legal fees", value: 130000 },
    { name: "Court fees", value: 2000 },
    { name: "Additional charges", value: 20000 },
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Replace with API endpoint
        const response = await fetch("/api/realtime-data");
        const result = await response.json();
        setData1([
          { name: "Legal fees", value: result.legalFees },
          { name: "Court fees", value: result.courtFees },
          { name: "Additional charges", value: result.additionalCharges },
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
  }, []);

  // Total amount
  const total = data1.reduce((sum, item) => sum + item.value, 0);

  // Function to get remaining value for the background
  const getRemainingValue = (value, total) => total - value;

  // For Overall accuracy pie chart
  const [data2, setData2] = useState({
    Revenue: 200000,
    Expenses: 10000,
    NetProfit: 20000,
  });

  // Convert object to array
  const pieData = Object.entries(data2).map(([key, value]) => ({
    name: key,
    value: value,
  }));

  //Top clients pie chart
  // Define total reference revenue
  const TOTAL_REVENUE = 600000; // Adjust based on business data

  const [data3, setData3] = useState([
    { name: "Client A", value: 200000 },
    { name: "Client B", value: 150000 },
    { name: "Client C", value: 100000 },
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Replace with API endpoint
        const response = await fetch("/api/realtime-data");
        const result = await response.json();
        setData3([
          { name: "Client A", value: result.clientA },
          { name: "Client B", value: result.clientB },
          { name: "Client C", value: result.clientC },
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
  }, []);

  // Calculate the remaining revenue
  const totalClientRevenue = data3.reduce(
    (sum, client) => sum + client.value,
    0
  );
  const remainingValue = Math.max(TOTAL_REVENUE - totalClientRevenue, 0); // Ensure it's not negative

  // Top revenue breakdown by type (Pie chart)
  const [data4, setData4] = useState([
    { name: "Debt", value: 125000 },
    { name: "Consultation", value: 130000 },
    { name: "Others", value: 150000 },
  ]);

  // For legal proceedings tabs
  const tabs = [
    { label: "Case overview", to: "/legal_1" },
    { label: "Billing schedule", to: "/legal_2" },
    { label: "Reports and analytics", to: "/legal_3" },
  ];

  return (
    <>
      <div className="w-full relative bg-neutrals-neutral-50 min-h-screen overflow-visible text-left text-base text-neutrals-neutral-900 font-open-sans-font-family-meta">
        {/* Navigation Panel */}
        <NavigationPanelLawyer navItems={navItems} />

        {/* Main */}
        <div className="w-full absolute top-[136px] flex flex-col items-start justify-start gap-8 px-4 md:px-4 lg:px-24 box-border">
          {/* Heading */}
          <div className="self-stretch bg-white border-neutrals-neutral-100 border-solid border-b-[1px] text-9xl flex flex-col items-start justify-start pt-0 px-0 pb-6 gap-1.5">
            <b className="relative">Legal proceedings and billing</b>
            <div className="relative text-base text-neutrals-neutral-300">
              Get to know time remaining for your LBA
            </div>
          </div>

          {/* Tabs */}
          <div className="flex flex-row items-start justify-start gap-[24px] text-neutrals-neutral-300">
            {tabs.map((tab) => (
              <TabState key={tab.to} label={tab.label} to={tab.to} />
            ))}
          </div>

          {/* Blocks */}
          <div className="self-stretch flex flex-col items-start justify-start gap-8 text-neutrals-neutral-900">
            <div className="self-stretch flex flex-col items-start justify-start gap-6">
              <div className="self-stretch relative font-semibold">
                Billing performance
              </div>
              <div className="self-stretch flex flex-col items-start justify-start gap-6">
                <div className="self-stretch flex flex-col md:flex-row lg:flex-row items-center justify-start gap-6 text-neutrals-neutral-300">
                  {/* Block 1 */}
                  <div className="w-full rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start">
                    <div className="self-stretch flex flex-row items-start justify-between p-6 gap-0">
                      <div className="flex flex-col items-start justify-start gap-6">
                        <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-start justify-start p-2.5">
                          <img
                            className="w-5 relative h-5"
                            alt=""
                            src="assets/flash.svg"
                          />
                        </div>
                        <div className="flex flex-col items-start justify-start gap-2.5">
                          <div className="relative">Total revenue</div>
                          <b className="relative text-13xl text-neutrals-neutral-900">
                            £200,000
                          </b>
                        </div>
                      </div>
                      <img
                        className="w-5 relative h-5 overflow-hidden shrink-0"
                        alt=""
                        src="assets/more-vert.svg"
                      />
                    </div>
                  </div>
                  {/* Block 2 */}
                  <div className="w-full rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start">
                    <div className="self-stretch flex flex-row items-start justify-between p-6 gap-0">
                      <div className="flex flex-col items-start justify-start gap-6">
                        <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-start justify-start p-2.5">
                          <img
                            className="w-5 relative h-5"
                            alt=""
                            src="assets/money.svg"
                          />
                        </div>
                        <div className="flex flex-col items-start justify-start gap-2.5">
                          <div className="relative">Average billing amount</div>
                          <b className="relative text-13xl text-neutrals-neutral-900">
                            £2000
                          </b>
                        </div>
                      </div>
                      <img
                        className="w-5 relative h-5 overflow-hidden shrink-0"
                        alt=""
                        src="assets/more-vert.svg"
                      />
                    </div>
                  </div>
                  {/* Block 3 */}
                  <div className="w-full rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start">
                    <div className="self-stretch flex flex-row items-start justify-between p-6 gap-0">
                      <div className="flex flex-col items-start justify-start gap-6">
                        <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-start justify-start p-2.5">
                          <img
                            className="w-5 relative h-5"
                            alt=""
                            src="assets/calendar.svg"
                          />
                        </div>
                        <div className="flex flex-col items-start justify-start gap-2.5">
                          <div className="relative">Billing frequency</div>
                          <b className="relative text-13xl text-neutrals-neutral-900">
                            Monthly
                          </b>
                        </div>
                      </div>
                      <img
                        className="w-5 relative h-5 overflow-hidden shrink-0"
                        alt=""
                        src="assets/more-vert.svg"
                      />
                    </div>
                  </div>
                </div>

                {/* Line graph */}
                <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-col items-start justify-start p-6 gap-6 text-lg">
                  <div className="self-stretch flex flex-row items-center justify-between gap-0">
                    <div className="relative font-semibold">
                      Monthly revenue trends
                    </div>
                    <CTAs
                      type="Secondarybtn"
                      text="Export"
                      borderColor="border-neutrals-neutral-100"
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            stroke="#2d404e"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                            d="M16.44 8.9c3.6.31 5.07 2.16 5.07 6.21v.13c0 4.47-1.79 6.26-6.26 6.26H8.74c-4.47 0-6.26-1.79-6.26-6.26v-.13c0-4.02 1.45-5.87 4.99-6.2M12 15V3.62M15.35 5.85L12 2.5 8.65 5.85"
                          ></path>
                        </svg>
                      }
                    />
                  </div>
                  <div className="self-stretch h-[292px] flex flex-col items-end justify-center text-center text-sm">
                    <ResponsiveContainer width="100%" height="100%">
                      <LineChart
                        data={data}
                        margin={{ top: 20, right: 30, left: 20, bottom: 15 }}
                      >
                        <defs>
                          <linearGradient
                            id="colorActions"
                            x1="0"
                            y1="0"
                            x2="0"
                            y2="1"
                          >
                            <stop
                              offset="0%"
                              stopColor="#2563EB"
                              stopOpacity={0.5}
                            />
                            <stop
                              offset="100%"
                              stopColor="#2563EB"
                              stopOpacity={0}
                            />
                          </linearGradient>
                        </defs>

                        <CartesianGrid
                          strokeDasharray="3 3"
                          horizontal={true}
                          vertical={true}
                        />
                        <XAxis
                          dataKey="month"
                          label={{
                            value: "Months",
                            position: "insideBottom",
                            offset: -10,
                          }}
                          tick={{ fill: "#888" }}
                        />
                        <YAxis
                          label={{
                            value: "Revenue",
                            angle: -90,
                            position: "insideLeft",
                          }}
                          tick={{ fill: "#888" }}
                        />
                        <Tooltip />
                        <Area
                          type="monotone"
                          dataKey="revenue"
                          stroke="none"
                          fill="url(#colorActions)"
                        />
                        <Line
                          type="monotone"
                          dataKey="revenue"
                          stroke="#2563EB"
                          strokeWidth={2}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </div>

                {/* Table */}
                <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs flex flex-col items-start justify-start text-sm">
                  <div className="w-full rounded-t-3xs rounded-b-none border-neutrals-neutral-100 border-solid border-t-[1px] border-r-[1px] border-l-[1px] box-border flex flex-row items-center justify-between py-5 px-6 gap-0 text-lg">
                    <div className="flex flex-row items-center justify-start gap-2.">
                      <div className="relative font-semibold">
                        Revenue breakdown
                      </div>
                      <div className="rounded-[5px] bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-start py-0.5 px-2 gap-1.5 text-sm">
                        <div className="w-1.5 relative rounded-[50%] bg-primary-primary-500 h-1.5" />
                        <div className="relative font-semibold">10 entries</div>
                      </div>
                    </div>
                    <CTAs
                      type="Secondarybtn"
                      text="Download"
                      borderColor="border-neutrals-neutral-100"
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M9 11v6l2-2M9 17l-2-2"
                            stroke="#2d404e"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                          <path
                            d="M22 10v5c0 5-2 7-7 7H9c-5 0-7-2-7-7V9c0-5 2-7 7-7h5"
                            stroke="#2d404e"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                          <path
                            d="M22 10h-4c-3 0-4-1-4-4V2l8 8Z"
                            stroke="#2d404e"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      }
                      onClick={openDownloadModalTables}
                    />
                  </div>
                  <div className="w-full border-neutrals-neutral-100 border-solid border-t-[1px] border-r-[1px] border-l-[1px] box-border flex flex-row items-center justify-end py-3 px-6 text-neutrals-neutral-300">
                    <div className="flex-1 flex flex-row items-start justify-between gap-0">
                      <div className="w-[294px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-bg-primary border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-row items-center justify-start py-2.5 px-3.5">
                        <div className="flex flex-row items-center justify-start gap-2.5">
                          <SearchNormal1 size={20} color="#2D404E" />

                          <div className="relative">{`Search `}</div>
                        </div>
                      </div>
                      <CTAs
                        type="Secondarybtn"
                        text="Filter"
                        borderColor="border-neutrals-neutral-100"
                        onClick={openRevenueFilter}
                        icon={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M3 7h18M6 12h12M10 17h4"
                              stroke="#2d404e"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            ></path>
                          </svg>
                        }
                      />
                    </div>
                  </div>
                  <div className="w-full flex flex-col items-start justify-start">
                    <div className="w-full h-auto flex flex-col items-start justify-start">
                      <div className="self-stretch flex flex-row items-start justify-start">
                        <table className="min-w-full divide-y divide-gray-200 border-collapse">
                          <thead className="bg-column-bg">
                            <tr>
                              <th
                                scope="col"
                                className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-l-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                              >
                                Client name
                              </th>
                              <th
                                scope="col"
                                className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                              >
                                Case type
                              </th>
                              <th
                                scope="col"
                                className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                              >
                                Billing amount
                              </th>
                              <th
                                scope="col"
                                className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                              >
                                Court fees
                              </th>
                              <th
                                scope="col"
                                className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                              >
                                Legal fees
                              </th>
                              <th
                                scope="col"
                                className="items-start justify-start py-3 px-4 border-t-[1px] border-r-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                              >
                                Total revenue
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-neutrals-neutral-50 divide-y divide-gray-200">
                            {revenue_breakdown.map((RevenueFilter) => (
                              <tr
                                key={RevenueFilter.id}
                                className="hover:bg-gray"
                              >
                                <td className="p-4 items-start border-solid border-b-[1px] border-l-[1px] border-neutrals-neutral-100">
                                  {RevenueFilter.name}
                                </td>
                                <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100">
                                  {RevenueFilter.type}
                                </td>
                                <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100">
                                  {RevenueFilter.amount}
                                </td>
                                <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100">
                                  {RevenueFilter.court_fees}
                                </td>
                                <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100">
                                  {RevenueFilter.legal_fees}
                                </td>
                                <td className="p-4 items-start border-solid border-b-[1px] border-r-[1px] border-neutrals-neutral-100">
                                  {RevenueFilter.revenue}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  {/* Pagination */}
                  <div className="w-full rounded-t-none rounded-b-3xs box-border flex flex-row items-center justify-between pt-3 px-6 pb-4 border-r-[1px] border-solid border-neutrals-neutral-100 border-b-[1px] border-l-[1px]">
                    <CTAs
                      type="Secondarybtn"
                      text="Previous"
                      borderColor="border-neutrals-neutral-100"
                    />
                    <div className="relative">Page 1 of 10</div>
                    <CTAs
                      type="Secondarybtn"
                      text="Next"
                      borderColor="border-neutrals-neutral-100"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Financial insights */}
          <div className="self-stretch flex flex-col items-start justify-start gap-6">
            <div className="self-stretch border-neutrals-neutral-100 border-solid border-b-[1px] flex flex-row items-start justify-between pt-0 px-0 pb-6 gap-0">
              <div className="relative font-semibold">Financial insights</div>
              <CTAs
                type="Secondarybtn"
                text="Export"
                borderColor="border-neutrals-neutral-100"
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      stroke="#2d404e"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M16.44 8.9c3.6.31 5.07 2.16 5.07 6.21v.13c0 4.47-1.79 6.26-6.26 6.26H8.74c-4.47 0-6.26-1.79-6.26-6.26v-.13c0-4.02 1.45-5.87 4.99-6.2M12 15V3.62M15.35 5.85L12 2.5 8.65 5.85"
                    ></path>
                  </svg>
                }
                onClick={openExportModalImage}
              />
            </div>

            {/* Multi-pie chart */}
            <div className="flex flex-row items-start justify-start gap-6 text-lg">
              <div className="w-[506px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start p-6 gap-6">
                <div className="self-stretch bg-white border-neutrals-neutral-100 border-solid border-b-[1px] flex flex-row items-center justify-between pt-0 px-0 pb-6 gap-0">
                  <div className="relative font-semibold">Cost breakdown</div>
                  <img
                    className="w-5 relative h-5 overflow-hidden shrink-0"
                    alt=""
                    src="assets/more-vert.svg"
                  />
                </div>
                <div className="self-stretch flex flex-row items-start justify-start gap-[24px] text-center text-sm text-neutrals-neutral-300">
                  <div className="w-60 h-60 flex flex-row items-center justify-center relative gap-[10px]">
                    <div className="flex flex-row items-start justify-start relative gap-[10px] z-[0]">
                      <PieChart width={234} height={234} viewBox="0 0 234 234">
                        {/*  Base Background Ring */}
                        <Pie
                          data={[{ value: total }]}
                          cx="50%"
                          cy="50%"
                          innerRadius={95}
                          outerRadius={115}
                          fill={BG_COLOR}
                          dataKey="value"
                          stroke="none"
                        />

                        {/* Largest Ring - Overall Accuracy */}
                        <Pie
                          data={[
                            { value: data1[0].value },
                            { value: getRemainingValue(data1[0].value, total) },
                          ]}
                          cx="50%"
                          cy="50%"
                          innerRadius={95}
                          outerRadius={115}
                          dataKey="value"
                          stroke="none"
                          paddingAngle={3}
                          cornerRadius={100}
                          startAngle={90}
                        >
                          <Cell fill={COLORS[0]} />
                          <Cell fill="transparent" />
                        </Pie>

                        {/* Base Background Ring for Middle Ring */}
                        <Pie
                          data={[{ value: total }]}
                          cx="50%"
                          cy="50%"
                          innerRadius={70}
                          outerRadius={90}
                          fill={BG_COLOR}
                          dataKey="value"
                          stroke="none"
                        />

                        {/* Middle Ring - False Positive */}
                        <Pie
                          data={[
                            { value: data1[1].value },
                            { value: getRemainingValue(data1[1].value, total) },
                          ]}
                          cx="50%"
                          cy="50%"
                          innerRadius={70}
                          outerRadius={90}
                          dataKey="value"
                          stroke="none"
                          paddingAngle={3}
                          cornerRadius={100}
                        >
                          <Cell fill={COLORS[1]} />
                          <Cell fill={BG_COLOR} />
                        </Pie>

                        {/* Base Background Ring for Smallest Ring */}
                        <Pie
                          data={[{ value: total }]}
                          cx="50%"
                          cy="50%"
                          innerRadius={45}
                          outerRadius={65}
                          fill={BG_COLOR}
                          dataKey="value"
                          stroke="none"
                        />

                        {/* Smallest Ring - True Positive */}
                        <Pie
                          data={[
                            { value: data1[2].value },
                            { value: getRemainingValue(data1[2].value, total) },
                          ]}
                          cx="50%"
                          cy="50%"
                          innerRadius={45}
                          outerRadius={65}
                          dataKey="value"
                          stroke="none"
                          paddingAngle={3}
                          cornerRadius={100}
                        >
                          <Cell fill={COLORS[2]} />
                          <Cell fill={BG_COLOR} />
                        </Pie>
                        <Tooltip />
                      </PieChart>
                    </div>
                    <div className="w-full !m-[0] absolute top-[90px] flex flex-col items-center justify-start gap-[2px] z-[1]">
                      <div className="relative">Total fees</div>
                      <b className="relative text-5xl text-neutrals-neutral-900 text-left">
                        {total}
                      </b>
                    </div>
                  </div>
                  <div className="flex-1 h-[216px] flex flex-col items-start justify-between text-right">
                    <div className="flex flex-row items-start justify-start gap-[6px]">
                      <div className="flex flex-row items-start justify-start pt-1.5 px-0 pb-0">
                        <div className="w-2 relative rounded-[50%] bg-primary-primary-500 h-2" />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-[4px]">
                        <div className="relative">Legal fees</div>
                        <div className="relative text-5xl font-semibold text-neutrals-neutral-900 text-left">
                          £130,000
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-row items-start justify-start gap-[6px]">
                      <div className="flex flex-row items-start justify-start pt-1.5 px-0 pb-0">
                        <div className="w-2 relative rounded-[50%] bg-primary-primary-300 h-2" />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-[4px]">
                        <div className="relative">Court fees</div>
                        <div className="relative text-5xl font-semibold text-neutrals-neutral-900 text-left">
                          £2000
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-row items-start justify-start gap-[6px]">
                      <div className="flex flex-row items-start justify-start pt-1.5 px-0 pb-0">
                        <div className="w-2 relative rounded-[50%] bg-primary-primary-100 h-2" />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-[4px]">
                        <div className="relative">Additional charges</div>
                        <div className="relative text-5xl font-semibold text-neutrals-neutral-900 text-left">
                          £20,000
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Comparision */}
              <div className="w-[506px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border flex flex-col items-start justify-start p-6 gap-[24px] text-base border-[1px] border-solid border-neutrals-neutral-100">
                <div className="self-stretch flex flex-row items-center justify-between pt-0 px-0 pb-6 border-b-[1px] border-solid border-neutrals-neutral-100">
                  <div className="relative font-semibold">Comparision</div>
                  <img
                    className="w-5 relative h-5 overflow-hidden shrink-0"
                    alt=""
                    src="assets/more-vert.svg"
                  />
                </div>
                <div className="self-stretch flex flex-row items-start justify-start gap-[24px] text-right text-sm text-neutrals-neutral-300">
                  <div className="w-60 h-60">
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                        <Pie
                          data={pieData}
                          cx="50%"
                          cy="50%"
                          innerRadius={70}
                          outerRadius={110}
                          fill="#E5E5E5"
                          dataKey="value"
                          stroke="none"
                        >
                          {pieData.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS_2[index % COLORS_2.length]}
                            />
                          ))}
                        </Pie>
                        <Tooltip />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>

                  <div className="flex-1 h-[216px] flex flex-col items-start justify-between">
                    <div className="self-stretch flex flex-row items-start justify-start gap-[6px]">
                      <div className="flex flex-row items-start justify-start pt-1.5 px-0 pb-0">
                        <div className="w-2 relative rounded-[50%] bg-primary-primary-500 h-2" />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-[4px]">
                        <div className="relative">Revenue</div>
                        <div className="relative text-5xl font-semibold text-neutrals-neutral-900 text-left">
                          £200,000
                        </div>
                      </div>
                    </div>
                    <div className="self-stretch flex flex-row items-start justify-start gap-[6px]">
                      <div className="flex flex-row items-start justify-start pt-1.5 px-0 pb-0">
                        <div className="w-2 relative rounded-[50%] bg-primary-primary-300 h-2" />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-[4px]">
                        <div className="relative">Expenses</div>
                        <div className="relative text-5xl font-semibold text-neutrals-neutral-900 text-left">
                          £2000
                        </div>
                      </div>
                    </div>
                    <div className="self-stretch flex flex-row items-start justify-start gap-[6px]">
                      <div className="flex flex-row items-start justify-start pt-1.5 px-0 pb-0">
                        <div className="w-2 relative rounded-[50%] bg-primary-primary-100 h-2" />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-[4px]">
                        <div className="relative">Net profit</div>
                        <div className="relative text-5xl font-semibold text-neutrals-neutral-900 text-left">
                          £20,000
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Statistics */}
          <div className="self-stretch flex flex-col items-start justify-start gap-6">
            <div className="self-stretch border-neutrals-neutral-100 border-solid border-b-[1px] flex flex-row items-start justify-between pt-0 px-0 pb-6 gap-0">
              <div className="relative font-semibold">Summary statistics</div>
              <CTAs
                type="Secondarybtn"
                text="Export"
                borderColor="border-neutrals-neutral-100"
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      stroke="#2d404e"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M16.44 8.9c3.6.31 5.07 2.16 5.07 6.21v.13c0 4.47-1.79 6.26-6.26 6.26H8.74c-4.47 0-6.26-1.79-6.26-6.26v-.13c0-4.02 1.45-5.87 4.99-6.2M12 15V3.62M15.35 5.85L12 2.5 8.65 5.85"
                    ></path>
                  </svg>
                }
                onClick={openExportModalImage}
              />
            </div>
            <div className="flex flex-row items-start justify-start gap-[24px] text-lg">
              <div className="w-[506px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border flex flex-col items-start justify-start p-6 gap-[24px] border-[1px] border-solid border-neutrals-neutral-100">
                <div className="self-stretch bg-neutrals-neutral-50 flex flex-row items-center justify-between pt-0 px-0 pb-6 border-b-[1px] border-solid border-neutrals-neutral-100">
                  <div className="relative font-semibold">
                    Top clients by revenue
                  </div>
                  <img
                    className="w-5 relative h-5 overflow-hidden shrink-0"
                    alt=""
                    src="assets/more-vert.svg"
                  />
                </div>
                <div className="self-stretch flex flex-row items-start justify-start gap-[24px] text-center text-sm text-neutrals-neutral-300">
                  <div className="w-60 h-60 flex flex-row items-center justify-center relative gap-[10px]">
                    <div className="flex flex-row items-start justify-start relative gap-[10px] z-[0]">
                      <PieChart width={234} height={234} viewBox="0 0 234 234">
                        {/*  Base Background Ring */}
                        <Pie
                          data={[{ value: total }]}
                          cx="50%"
                          cy="50%"
                          innerRadius={95}
                          outerRadius={115}
                          fill={BG_COLOR}
                          dataKey="value"
                          stroke="none"
                        />

                        {/* Largest Ring - Overall Accuracy */}
                        <Pie
                          data={[
                            { value: data3[0].value },
                            { value: remainingValue },
                          ]}
                          cx="50%"
                          cy="50%"
                          innerRadius={95}
                          outerRadius={115}
                          dataKey="value"
                          stroke="none"
                          paddingAngle={3}
                          cornerRadius={100}
                          startAngle={90}
                        >
                          <Cell fill={COLORS[0]} />
                          <Cell fill="transparent" />
                        </Pie>

                        {/* Base Background Ring for Middle Ring */}
                        <Pie
                          data={[{ value: total }]}
                          cx="50%"
                          cy="50%"
                          innerRadius={70}
                          outerRadius={90}
                          fill={BG_COLOR}
                          dataKey="value"
                          stroke="none"
                        />

                        {/* Middle Ring - False Positive */}
                        <Pie
                          data={[
                            { value: data3[1].value },
                            { value: remainingValue },
                          ]}
                          cx="50%"
                          cy="50%"
                          innerRadius={70}
                          outerRadius={90}
                          dataKey="value"
                          stroke="none"
                          paddingAngle={3}
                          cornerRadius={100}
                        >
                          <Cell fill={COLORS[1]} />
                          <Cell fill={BG_COLOR} />
                        </Pie>

                        {/* Base Background Ring for Smallest Ring */}
                        <Pie
                          data={[{ value: total }]}
                          cx="50%"
                          cy="50%"
                          innerRadius={45}
                          outerRadius={65}
                          fill={BG_COLOR}
                          dataKey="value"
                          stroke="none"
                        />

                        {/* Smallest Ring - True Positive */}
                        <Pie
                          data={[
                            { value: data3[2].value },
                            { value: remainingValue },
                          ]}
                          cx="50%"
                          cy="50%"
                          innerRadius={45}
                          outerRadius={65}
                          dataKey="value"
                          stroke="none"
                          paddingAngle={3}
                          cornerRadius={100}
                        >
                          <Cell fill={COLORS[2]} />
                          <Cell fill={BG_COLOR} />
                        </Pie>
                        <Tooltip />
                      </PieChart>
                    </div>
                  </div>
                  <div className="flex-1 h-[216px] flex flex-col items-start justify-between text-right">
                    <div className="flex flex-row items-start justify-start gap-[6px]">
                      <div className="flex flex-row items-start justify-start pt-1.5 px-0 pb-0">
                        <div className="w-2 relative rounded-[50%] bg-primary-primary-500 h-2" />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-[4px]">
                        <div className="relative">Client A</div>
                        <div className="relative text-5xl font-semibold text-neutrals-neutral-900 text-left">
                          £200,000
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-row items-start justify-start gap-[6px]">
                      <div className="flex flex-row items-start justify-start pt-1.5 px-0 pb-0">
                        <div className="w-2 relative rounded-[50%] bg-primary-primary-300 h-2" />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-[4px]">
                        <div className="relative">Client B</div>
                        <div className="relative text-5xl font-semibold text-neutrals-neutral-900 text-left">
                          £150,000
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-row items-start justify-start gap-[6px]">
                      <div className="flex flex-row items-start justify-start pt-1.5 px-0 pb-0">
                        <div className="w-2 relative rounded-[50%] bg-primary-primary-100 h-2" />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-[4px]">
                        <div className="relative">Client C</div>
                        <div className="relative text-5xl font-semibold text-neutrals-neutral-900 text-left">
                          £100,000
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-[506px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border flex flex-col items-start justify-start p-6 gap-[24px] text-base border-[1px] border-solid border-neutrals-neutral-100">
                <div className="self-stretch flex flex-row items-center justify-between pt-0 px-0 pb-6 border-b-[1px] border-solid border-neutrals-neutral-100">
                  <div className="relative font-semibold">
                    Top revenue breakdown by type
                  </div>
                  <img
                    className="w-5 relative h-5 overflow-hidden shrink-0"
                    alt=""
                    src="assets/more-vert.svg"
                  />
                </div>
                <div className="self-stretch flex flex-row items-start justify-start gap-[24px] text-right text-sm text-neutrals-neutral-300">
                  <div className="w-60 h-60">
                    <ResponsiveContainer>
                      <PieChart>
                        <Pie
                          data={data4}
                          cx="50%"
                          cy="50%"
                          innerRadius={70}
                          outerRadius={110}
                          fill="#E5E5E5"
                          dataKey="value"
                          stroke="none"
                        >
                          {data4.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS_2[index % COLORS_2.length]}
                            />
                          ))}
                        </Pie>
                        <Tooltip />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>

                  <div className="flex-1 h-[216px] flex flex-col items-start justify-between">
                    <div className="self-stretch flex flex-row items-start justify-start gap-[6px]">
                      <div className="flex flex-row items-start justify-start pt-1.5 px-0 pb-0">
                        <div className="w-2 relative rounded-[50%] bg-primary-primary-500 h-2" />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-[4px]">
                        <div className="relative">Debt</div>
                        <div className="relative text-5xl font-semibold text-neutrals-neutral-900 text-left">
                          £125,000
                        </div>
                      </div>
                    </div>
                    <div className="self-stretch flex flex-row items-start justify-start gap-[6px]">
                      <div className="flex flex-row items-start justify-start pt-1.5 px-0 pb-0">
                        <div className="w-2 relative rounded-[50%] bg-primary-primary-300 h-2" />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-[4px]">
                        <div className="relative">Consultation</div>
                        <div className="relative text-5xl font-semibold text-neutrals-neutral-900 text-left">
                          £130,000
                        </div>
                      </div>
                    </div>
                    <div className="self-stretch flex flex-row items-start justify-start gap-[6px]">
                      <div className="flex flex-row items-start justify-start pt-1.5 px-0 pb-0">
                        <div className="w-2 relative rounded-[50%] bg-primary-primary-100 h-2" />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-[4px]">
                        <div className="relative">Others</div>
                        <div className="relative text-5xl font-semibold text-neutrals-neutral-900 text-left">
                          £150,000
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      {isExportModalImageOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeExportModalImage}
        >
          <ExportModalImage onClose={closeExportModalImage} />
        </PortalPopup>
      )}
      {isExportModalImage1Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeExportModalImage1}
        >
          <ExportModalImage onClose={closeExportModalImage1} />
        </PortalPopup>
      )}
      {isExportModalImage2Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeExportModalImage2}
        >
          <ExportModalImage onClose={closeExportModalImage2} />
        </PortalPopup>
      )}
      {isDownloadModalTablesOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeDownloadModalTables}
        >
          <DownloadModalTables onClose={closeDownloadModalTables} />
        </PortalPopup>
      )}
      {isRevenueFilterOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeRevenueFilter}
        >
          <RevenueFilter onClose={closeRevenueFilter} />
        </PortalPopup>
      )}
      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
    </>
  );
};

export default Legal_proceedings_3;
